import React from 'react';
import { Grid } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';

import { AssignEntitiesEnum } from 'Common/FieldEnum';

import { SiteGridContainer } from '../../containers/assignEntities/SiteGridContainer';
import { ItemGridContainer } from '../../containers/assignEntities/ItemGridContainer';

const AssignItemToSitesComponent = props => {
  const {
    allItemsData,
    loadingAllItems,
    allSitesData,
    loadingAllSites,
    setIsReadOnlyState,
    isReadOnly,
    setSiteGridInstance,
    setItemGridInstance,
    onFilteredChange,
    rightSideGridReactTableRef,
    isRightGridFiltered,
    resetGridPage,
    onResetPageOnDataChange,
    direction,
  } = props;

  return (
    <Grid>
      <Grid.Row columns={2}>
        <Grid.Column width={7}>
          <Field
            component={ItemGridContainer}
            name={AssignEntitiesEnum.ItemGridInfo}
            {...{
              dataSource: allItemsData,
              loadingAllItems,
              isLeftSideItemGrid: true,
              isRightSideSiteGrid: true,
              setIsReadOnlyState,
              isReadOnly,
              setItemGridInstance,
              resetGridPage,
              onResetPageOnDataChange,
              direction,
            }}
          />
        </Grid.Column>
        <Grid.Column width={9}>
          <Field
            component={SiteGridContainer}
            name={AssignEntitiesEnum.SiteGridInfo}
            {...{
              dataSource: allSitesData,
              loadingAllSites,
              isLeftSideItemGrid: true,
              isRightSideSiteGrid: true,
              setIsReadOnlyState,
              isReadOnly,
              setSiteGridInstance,
              onFilteredChange,
              rightSideGridReactTableRef,
              isRightGridFiltered,
              resetGridPage,
              onResetPageOnDataChange,
              direction,
            }}
          />
        </Grid.Column>
      </Grid.Row>
    </Grid>
  );
};

AssignItemToSitesComponent.propTypes = {
  allItemsData: PropTypes.array.isRequired,
  allSitesData: PropTypes.array.isRequired,
  resetGridPage: PropTypes.object.isRequired,
  setIsReadOnlyState: PropTypes.func,
  setSiteGridInstance: PropTypes.func,
  setItemGridInstance: PropTypes.func,
  onResetPageOnDataChange: PropTypes.func,
  onFilteredChange: PropTypes.func,
  isReadOnly: PropTypes.bool,
  direction: PropTypes.bool,
  loadingAllItems: PropTypes.bool,
  loadingAllSites: PropTypes.bool,
  isLeftSideItemGrid: PropTypes.bool,
  isRightSideSiteGrid: PropTypes.bool,
  isRightGridFiltered: PropTypes.bool,
  rightSideGridReactTableRef: PropTypes.object,
};

AssignItemToSitesComponent.defaultProps = {
  loadingAllItems: false,
  loadingAllSites: false,
  isReadOnly: true,
  direction: true,
  isLeftSideItemGrid: false,
  isRightSideSiteGrid: false,
  isRightGridFiltered: false,
  rightSideGridReactTableRef: null,
  setIsReadOnlyState: () => {},
  setSiteGridInstance: () => {},
  setItemGridInstance: () => {},
  onResetPageOnDataChange: () => {},
  onFilteredChange: () => {},
};

export default AssignItemToSitesComponent;



// WEBPACK FOOTER //
// ./src/pages/utilities/assignentities/components/assignEntities/AssignItemToSites.js